export default __webpack_public_path__ + "static/1270-a13cd5bcc21df4017be52510fb05dc7e.gif";